// Copyright (c) 2024, Riverence and contributors
// For license information, please see license.txt

frappe.provide('riverence')

riverence.scan_warehouse = async r => {
	const event = new CustomEvent('scannedWarehouse', { detail: r })
	window.dispatchEvent(event)
}
